/**
 * Performance component module.
 * @module advisor/components/performance/Performance
 */
import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {_openModal} from '../../reducers/modals';
import {Column, Row, DescriptiveText, Image} from '../../index';
import {formatter} from '../../utils/utils';
import performanceRingNeutral from './performanceRingNeutral.png';
import performanceRingUp from './performanceRingUp.png';
import performanceRingDown from './performanceRingDown.png';

export const percentFormatter = formatter('percent', {decimalPlaces: 1});

/**
 * Performance component
 * @name Performance
 */
const Performance = ({performance, size, labelPosition, action}) => {
  const formatted = percentFormatter((performance || 0) * 100);
  const imgSize = size === 'sm' ? '30px' : '50px';
  const preset = size === 'sm' ? 'standard' : 'dataLabelLarge';

  let img = performanceRingNeutral;

  if (performance > 0) {
    img = performanceRingUp;
  } else if (performance < 0) {
    img = performanceRingDown;
  }

  const _Wrapper = labelPosition === 'bottom' ? Column : Row;

  return <_Wrapper layout={{shrink: 0}} width={'fit-content'} action={action}>
    <Image src={img} maxHeight={imgSize} maxWidth={imgSize} margin={'5px'}/>
    <DescriptiveText preset={preset}>{formatted}</DescriptiveText>
  </_Wrapper>;
};

const mapDispatchToProps = dispatch => ({
  openModal: content => dispatch(_openModal(content)),
});

export default connect(null, mapDispatchToProps)(Performance);

Performance.propTypes = {
  /**
   * Performance value (decimal)
   */
  performance: PropTypes.number.isRequired,
  /**
   * Component size
   */
  size: PropTypes.oneOf(['sm', 'lg']).isRequired,
  /**
   * Performance value label position
   */
  labelPosition: PropTypes.oneOf(['bottom', 'right']).isRequired,
  /**
   * Optional function to execute on click
   */
  action: PropTypes.func,
};
